export default "__VITE_ASSET__D1p4PvSp__"